import { APIError } from "@/adapters/api";

export const RDO_ALREADY_EXISTS = "rdo_already_exists";

const RDO_ERROR_MESSAGES: Record<string, string> = {
	rdo_already_exists: "Já existe um Relatório de Obra para esta data.",
	rdo_not_editable: "Este Relatório de Obra não está mais em rascunho e não pode ser editado.",
	rdo_not_deletable: "Só rascunhos podem ser excluídos.",
	rdo_not_failed: "Só um Relatório de Obra com falha pode ser reprocessado.",
	rdo_not_finalized: "Só um Relatório de Obra finalizado pode receber uma revisão.",
	rdo_revision_exists: "Já existe uma revisão aberta para este Relatório de Obra.",
	rdo_pdf_unavailable: "O PDF deste Relatório de Obra ainda não está disponível.",
	rdo_generation_unavailable:
		"A geração de PDF está indisponível no momento. Tente novamente mais tarde.",
	rdo_preview_unavailable: "Não foi possível gerar a prévia. Tente novamente.",
};

const FIELD_LABELS: Record<string, string> = {
	activities: "atividades",
	technical_manager: "responsável técnico",
	report_date: "data do relatório",
	photos: "fotos",
	file: "arquivo",
	title: "título",
	stage_id: "etapa",
	status: "status",
	weather_condition: "clima",
	observations: "observações",
	description: "descrição",
	scheduled_services: "serviços programados",
	photo_size: "tamanho das fotos",
};

const VIOLATION_MESSAGES: Record<string, string> = {
	required: "é obrigatório",
	future: "não pode estar no futuro",
	invalid: "é inválido",
	max_6: "excede o limite de 6",
	max_30: "excede o limite de 30",
	max_500: "excede o limite de 500 caracteres",
	max_size: "excede o tamanho máximo",
	unsupported_type: "tem um formato não suportado",
	too_long: "é muito longo",
};

export function existingRdoIdFromError(err: unknown): string | undefined {
	if (!(err instanceof APIError)) return undefined;
	if (err.reason !== RDO_ALREADY_EXISTS && err.code !== RDO_ALREADY_EXISTS) {
		return undefined;
	}
	return err.violations.rdo_id || undefined;
}

export function rdoErrorMessage(err: unknown, fallback: string): string {
	if (!(err instanceof APIError)) return fallback;
	const known = RDO_ERROR_MESSAGES[err.reason] ?? RDO_ERROR_MESSAGES[err.code];
	if (known) return known;
	const violations = Object.entries(err.violations);
	if (violations.length > 0) {
		return violations
			.map(([field, description]) => {
				const label = FIELD_LABELS[field] ?? field;
				const detail = VIOLATION_MESSAGES[description] ?? description;
				return `${label[0]?.toUpperCase()}${label.slice(1)} ${detail}.`;
			})
			.join(" ");
	}
	return err.message || fallback;
}
